import {
  ReasonDefinition,
  SearchedUnassignedRc,
} from '@modules/taxonomy/store/types';
import { UnassignedRc } from 'generated/graphql';

export const getSelectedUnassignedDefinitions = (
  reasonDefinitions: ReasonDefinition[] | undefined,
): (UnassignedRc | SearchedUnassignedRc)[] => {
  if (!reasonDefinitions) {
    return [];
  }

  return reasonDefinitions
    ?.filter(
      (definition): definition is UnassignedRc | SearchedUnassignedRc =>
        definition.__typename === 'UnassignedRC' ||
        definition.__typename === 'SearchedUnassignedRc',
    )
    .filter((definition) => definition.isSelected);
};
